<template>
    <div class="booksearch">
        <div class="searchbar">
            <input @input="onInput" v-model="text"/>
        </div>
        <div class="result">
            <label>搜索结果</label>
            <div v-for="(book, i) in this.result" :key="i" @click="onSelect(book, i)" class="item">
                <span>{{book.name}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            text: '',
            result: {},
        };
    },
    props: {
        value: {
            default() {
                return {};
            }
        }
    },
    methods: {
        onInput() {
            this.result = {};
            if (!this.text) return;
            Object.keys(this.value).forEach(key => {
                let book = this.value[key];
                if (-1 != book.name.indexOf(this.text)) {
                    this.result[key] = book;
                }
            });
        },
        onSelect(book, i) {
            this.$emit('open-modal', book, i);
        }
    }
}
</script>

<style lang="less" scoped>
.booksearch {
    text-align: center;

    .searchbar {
        display: inline-block;
        width: 80%;

        input {
            box-sizing: border-box;
            width: 100%;
            font-size: 16px;
        }
    }

    .result {
        .item {
            padding: .5em 1em;
            text-align: left;
            color: white;
        }
    }
}
</style>
